module.exports = __webpack_public_path__ + "static/media/jinray-circular-balcony.c52d448b.jpg";